export default __webpack_public_path__ + "static/media/leave.b2f36cdd.svg";